<script setup lang="ts">
import { Check } from './icons'
import { cn } from '@/lib/utils'

const props = withDefaults(
  defineProps<{ modelValue: boolean; disabled?: boolean; label?: string; class?: string }>(),
  { disabled: false, label: '', class: '' },
)
const emit = defineEmits<{ 'update:modelValue': [value: boolean] }>()
</script>

<template>
  <label
    :class="
      cn(
        'inline-flex cursor-pointer items-center gap-2 text-sm select-none',
        disabled && 'cursor-not-allowed opacity-50',
        props.class,
      )
    "
  >
    <span
      :class="[
        'flex size-4 shrink-0 items-center justify-center rounded-[4px] border transition-colors duration-150',
        modelValue ? 'border-primary bg-primary text-primary-foreground' : 'border-input bg-background',
      ]"
    >
      <!-- 未选中时**必须把勾藏起来**：框底是白的（`bg-background`），而这个图标
           不设色时继承的是正文深色 —— 于是没勾的框里也画着一个清清楚楚的勾，
           跟选中态肉眼分不出来。用 opacity 而不是 v-if，勾选时才有过渡可言。 -->
      <Check
        :class="['size-3 transition-opacity duration-150', modelValue ? 'opacity-100' : 'opacity-0']"
        aria-hidden="true"
      />
    </span>
    <!-- 不用 `sr-only` 藏它：那是 `position:absolute`，input 脱离滚动流后
         获焦时浏览器滚的是外层 overlay —— 在抽屉/对话框里勾一下，整个面板被顶出视口。 -->
    <input
      type="checkbox"
      class="size-0 appearance-none border-0 p-0 opacity-0"
      :checked="modelValue"
      :disabled="disabled"
      @change="emit('update:modelValue', ($event.target as HTMLInputElement).checked)"
    />
    <slot>{{ label }}</slot>
  </label>
</template>
